import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {main_url} from './basefile';

import {
  Box,
  Typography,
  Paper,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Slider,
  Switch,
  Button,
} from '@mui/material';

  const handleUpdateSchedule = (execution_pk, schedule_pk) => {

    // check all anserver submitted before completing schedule
    const token = localStorage.getItem('authToken');
    const url = `${main_url}/api/v1/executions/${execution_pk}/schedules/${schedule_pk}/`;

    const payload = {
      status: "completed",
      completed_at: new Date().toISOString(),
      note: 'NA',
    };

    fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((data) => {
        alert('Schedule updated successfully.');
        //setIsDateSaved(true); 
      })
      .catch((err) => {
        alert('Failed to update schedule.');
         //setIsDateSaved(true); 
      });
  };

const DynamicAnswerSubmit = ({ project_pk, execution_pk, schedule_pk }) => {

  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState([]);

  const token = localStorage.getItem('authToken');

  // alert("pro ID" + project_pk +"sch ID " +schedule_pk + "execu ID "+ execution_pk );

  const handleComplete =  (execution_pk, schedule_pk) => {

      const unanswered = questions.filter(q => !submitted.includes(q.id));
      if (unanswered.length > 0) {
        alert("Please answer all questions before completing the schedule.");
        return;
      }

      const token = localStorage.getItem('authToken');
      const url = `${main_url}/api/v1/executions/${execution_pk}/schedules/${schedule_pk}/`;

      const payload = {
      status: 'completed',
      completed_at: new Date().toISOString(),
      completed_at: null,
      note: 'NA',
      };

      fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      })
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((data) => {
          alert('Schedule updated successfully.');
          // setIsDateSaved(true); // Hide date box
      })
      .catch((err) => {
        alert('Failed to update schedule.');
        // setIsDateSaved(true); 
      });
        alert("Schedule completed!");
};

  useEffect(() => {
    //http://13.201.185.64:8000/api/v1/projects/{project_pk}/questions/
    const url = ` ${main_url}/api/v1/projects/${project_pk}/questions/`;
    fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then((data) => {
       // alert(JSON.stringify(data.results));

        setQuestions(Array.isArray(data.results) ? data.results : [data]);

        const initialAnswers = {};
        data.forEach((q) => {
          if (q.question_type === 'checkbox') {
            initialAnswers[q.id] = q.selected_options || [];
          } else if (q.question_type === 'multiple') {
            initialAnswers[q.id] = Array.isArray(q.selected_options) && q.selected_options.length > 0
    ? q.selected_options[0] // store only the first selected option
    : '';

           // initialAnswers[q.id] = q.selected_options ?? '';
          } else if (q.question_type === 'single') {
            initialAnswers[q.id] = q.text_answer ?? '';
          } else if (q.question_type === 'slider') {
            initialAnswers[q.id] = q.integer_answer ?? 0;
          } else if (q.question_type === 'bool') {
            initialAnswers[q.id] = q.boolean_answer ?? false;
          }
        });
        setAnswers(initialAnswers);
      })
      .catch((err) => {
        console.error('Failed to load questions', err);
      });
  }, []);

  const handleChange = (question, value) => {
    setAnswers((prev) => ({
      ...prev,
      [question.id]: value,
    }));
  };

  const submitSingleAnswer = async (question) => {
    /*
      {
          "question": 0,
          "schedule": 0,
          "text_answer": "string",
          "boolean_answer": true,
          "integer_answer": -2147483648,
          "selected_options": [],
          "images": []
      }
          */

    const userAnswer = answers[question.id];
    const payload = {
      question: question.id,
      schedule: schedule_pk,
      text_answer: null,
      boolean_answer: null,
      integer_answer: null,
      selected_options: [],
    };

    //alert(question.question_type);
    switch (question.question_type) {

      case 'single':
        payload.text = userAnswer?.toString() ?? '';
       // payload.text = userAnswer;
          if (userAnswer) {
          payload.selected_options = [parseInt(userAnswer, 10)];
          } else {
          payload.selected_options = [];
          }
        break;
    
      case 'multiple':
        payload.selected_options = Array.isArray(userAnswer)
          ? userAnswer.map(Number)
          : [];
        break;
      case 'slider':
        payload.integer_answer = Number(userAnswer);
        break;
      case 'bool':
        payload.boolean_answer = Boolean(userAnswer);
        break;
      case 'text':
        payload.text_answer = userAnswer;
        break;
      default:
        break;
    }

    // PATCH http://13.201.185.64:8000/api/v1/executions/{execution_pk}/schedules/{schedule_pk}/answers/{id}/
    const response = await fetch(

      `${main_url}/api/v1/executions/${execution_pk}/schedules/${schedule_pk}/answers/`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    );

    if (response.ok) {
      alert(`Submitted question ${question.id} successfully`);
       setSubmitted((prev) => [...prev, question.id]);
    } else {
      alert(`Failed to submit question ${question.id}`);
    }
  };

  const renderOptions = (q) => {
    const value = answers[q.id];
    switch (q.question_type) {
      case 'single':
        return (
          <RadioGroup
           name={`question-${q.id}`}
            value={value ?? ''}
            onChange={(e) => handleChange(q, e.target.value)}
          >
            {q.options.map((opt) => (
              <FormControlLabel
                key={opt.id}
                value={opt.id}
                control={<Radio />}
                label={opt.text}
              />
            ))}
          </RadioGroup>
        );

      case 'multiple':
        const selected = value || [];
        return q.options.map((opt) => (
          <FormControlLabel
            key={opt.id}
            control={
              <Checkbox
                checked={selected.includes(opt.id)}
                onChange={(e) => {
                  const updated = e.target.checked
                    ? [...selected, opt.id]
                    : selected.filter((id) => id !== opt.id);
                  handleChange(q, updated);
                }}
              />
            }
            label={opt.text}
          />
        ));

      case 'slider':
        
        return (
         
          < Slider
            min={0}
            max={50}
            step={1}
            value={value ?? 0}
            onChangeCommitted={(e, val) => handleChange(q, val)}
            valueLabelDisplay="auto" 
            sx={{ ml:5, mt:2,
               width: 700,
              '& .MuiSlider-thumb': {
                height: 34,
                width: 34,
              },
              '& .MuiSlider-track': {
                height: 20,
              },
              '& .MuiSlider-rail': {
                height: 15,
              },
             }}
          />
        );

      case 'bool':
        return (
          <FormControlLabel
            control={
              <Switch
                checked={value ?? false}
                onChange={(e) => handleChange(q, e.target.checked)}
              />
            }
            label={value ? 'Yes' : 'No'}
          />
        );

       case 'text':
        return (
          <TextField
           sx={{ mt:3,width: 500 }} 
            label="Type Your Answer"
            value={value ?? ''}
            onChange={(e) => handleChange(q, e.target.value)}
            variant="outlined"
          />
        );

      default:
        return <Typography color="error">Unsupported type</Typography>;
    }
  };

  return (
    <Box sx={{ p: 4 , ml:35 , bgcolor: '#e9f0f0ff', width:900, borderRadius:2}}>
      <Typography variant="h5" gutterBottom sx={{ml:4, fontWeight:'bold'}}>
        Questionnaire
      </Typography><br></br>
      {questions.map((q,index) => (
        <Paper key={q.id} sx={{ ml:3,p: 3, mb: 2, width: 800 , borderRadius:3}}>
          <Typography variant="subtitle1" gutterBottom>
           {/* {q.order+1})
            { " "+ q.text} */}
            {`${index + 1}) ${q.text}`}
          </Typography>
          {renderOptions(q)}

<br></br><br></br>
{submitted.includes(q.id) ? (
  <Typography variant="h5" sx={{ mt: 4 }} color="green">Answered</Typography>
) : (
   
  <Button
    variant="contained" 
    sx={{ mt: 2,borderRadius:2, justifyContent: 'flex-end',display: 'flex', }}
    onClick={() => submitSingleAnswer(q)}
  >
    Submit Answer
  </Button>
)}
</Paper>
      ))}
 <br></br>
       <Button variant="contained" color="primary"  sx={{ml:40 , backgroundColor:'#245463'}}  onClick={() => handleComplete(execution_pk, schedule_pk)} 
        >
          Complete Schedule
        </Button>
    </Box>
  );
};

export default DynamicAnswerSubmit;
